<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <div class='global-panel' v-loading.body="loading.index" style="padding: 10px">
      <div class="global-header">
        <el-page-header @back="goBack" :content="title"></el-page-header>
      </div>
      <div class='global-body'>
        <el-row>
          <el-col :span="16">
            <el-card shadow="hover" style="margin: 10px;">
              <div style="clear: both">
                <div class="global-header">
                  <div class="global-title">评选项</div>
                  <div class='global-tbar'>
                    <el-button size="small" type="danger" @click="addEvalSubject()">新增</el-button>
                  </div>
                </div>
                <el-table :data="evalSubjectList" border stripe style="width: 100%" size="mini" highlight-current-row @current-change="handleEvalSubjectChange">
                  <el-table-column type="index" width="50"></el-table-column>
                  <el-table-column prop="subjectName" label="项目" min-width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="displayOrder" label="排序" width="100"></el-table-column>
                  <el-table-column prop="note" label="备注" min-width="100"></el-table-column>
                  <el-table-column label="操作" width="120" align="center" fixed="right" >
                    <template slot-scope="scope">
                      <el-button class="global-text-btn-success" size="mini" type="text" @click="showEvalSubject(scope.row)" style="margin-left: 10px;">编辑</el-button>
                      <el-button class="global-text-btn-danger" size="mini" type="text" @click="deleteEvalSubject(scope.row)" style="margin-left: 10px;">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
            <el-card shadow="hover" style="margin: 10px;">
              <div style="clear: both">
                <div class="global-header">
                  <div class="global-title">评选条目</div>
                  <div class='global-tbar'>
                    <el-button size="small" type="danger" @click="addEvalItem()">新增</el-button>
                  </div>
                </div>
                <el-table :data="evalItemList" border stripe style="width: 100%" size="mini" highlight-current-row >
                  <el-table-column type="index" width="50"></el-table-column>
                  <el-table-column prop="itemName" label="条目" min-width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="standard" label="标准" min-width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column prop="itemType" label="类型" width="100"></el-table-column>
                  <el-table-column prop="defaultScore" label="默认赋分" width="100"></el-table-column>
                  <el-table-column prop="maxScore" label="赋分上限" width="100"></el-table-column>
                  <el-table-column prop="displayOrder" label="排序" width="100"></el-table-column>
                  <el-table-column prop="note" label="备注" min-width="100"></el-table-column>
                  <el-table-column label="操作" width="120" align="center" fixed="right" >
                    <template slot-scope="scope">
                      <el-button class="global-text-btn-success" size="mini" type="text" @click="showEvalItem(scope.row)" style="margin-left: 10px;">编辑</el-button>
                      <el-button class="global-text-btn-danger" size="mini" type="text" @click="deleteEvalItem(scope.row)" style="margin-left: 10px;">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <div style="flex: 1">
              <el-card shadow="hover" style="margin: 10px;">
                <div class="global-header">
                  <div class="global-title">附件</div>
                  <div class='global-tbar'>
                    <el-upload :action="'rest/eval/uploadEvalAttach' "
                               :data="{evalId: currentEval.id}"
                               multiple
                               :on-progress="uploadProgress"
                               :on-error="uploadError"
                               :on-success="uploadSuccess"
                               :show-file-list='false'
                               :disabled="!currentEval.id">
                      <el-button type="primary" size="small" icon="el-icon-upload2" :disabled="!currentEval.id">上传</el-button>
                    </el-upload>
                  </div>
                </div>
                <el-table :data="attachList" style="width: 100%" row-key="id" border stripe size="mini" >
                  <el-table-column type="index" width="50"></el-table-column>
                  <el-table-column label="附件名" prop="fileName"></el-table-column>
                  <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                      <el-button class="global-text-btn-danger" type="text" size="small" @click="deleteEvalAttach(scope.row)" :disabled="!currentEval.id">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
              <el-card shadow="hover" style="margin: 10px;">
                <div class="global-header">
                  <div class="global-title">评选范围</div>
                  <div class='global-tbar'>
                    <el-button size="small" type="primary"  @click="selectStaff()" :disabled="!currentEval.id">选择教职工</el-button>
                  </div>
                </div>
                <el-table :data="scopeList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" >
                  <el-table-column type="index" width="50"></el-table-column>
                  <el-table-column label="工号" prop="seriaNo" min-width="100" ></el-table-column>
                  <el-table-column label="姓名" prop="staffName" min-width="100" ></el-table-column>
                  <el-table-column label="操作" width="100" align="center" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click="deleteEvalScope(scope.row)" type="text" style="color: #F56C6C" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <el-dialog :visible.sync="visible.evalSubjectForm" width="600px" v-loading="loading.edit" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="evalSubjectForm" :model="currentEvalSubject" label-width="70px" :rules="serverRules" size="small">
        <el-form-item label="项目" prop="subjectName">
          <el-input v-model="currentEvalSubject.subjectName"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="displayOrder">
          <el-input-number v-model="currentEvalSubject.displayOrder" :precision="0" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentEvalSubject.note" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.evalSubjectForm = false">取 消</el-button>
      <el-button type="primary" @click="saveEvalSubject()">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="visible.evalItemForm" width="600px" v-loading="loading.edit" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="evalItemForm" :model="currentEvalItem" label-width="70px" :rules="serverRules" size="small">
        <el-form-item label="条目" prop="itemName">
          <el-input v-model="currentEvalItem.itemName"></el-input>
        </el-form-item>
        <el-form-item label="标准" prop="standard">
          <el-input v-model="currentEvalItem.standard" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="itemType">
          <el-col :span="16">
            <el-select v-model="currentEvalItem.itemType" placeholder="请选择" @change="changeItemType">
              <el-option v-for="item in itemTypeCombo" :key="item.key" :label="item.value" :value="item.key"></el-option>
            </el-select>
          </el-col>
          <el-col :span="8" align="center">
            <el-button v-show="currentEvalItem.itemType && currentEvalItem.itemType!=='文本框'" type="text" size="small" @click="addOption()">增加选项</el-button>
          </el-col>
        </el-form-item>

        <div v-show="currentEvalItem.itemType && currentEvalItem.itemType!=='文本框'" v-for="(option, index) in currentEvalItem.options" style="border:1px solid #ccc;margin:18px 0;padding:18px 18px 0;">
          <el-form-item label="选项" :rules="{required: true, message: '选项不能为空', trigger: 'blur'}">
            <el-input v-model="option.optionName" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="分值" :rules="{required: true, message: '分值不能为空', trigger: 'blur'}">
            <el-col :span="16">
              <el-input-number v-model="option.score" :precision="1" :step="1"></el-input-number>
            </el-col>
            <el-col :span="8" align="center">
              <el-button type="text" style="color: #F56C6C" @click="removeOption(option)">删除</el-button>
            </el-col>
          </el-form-item>
        </div>

        <el-form-item label="默认赋分" prop="defaultScore">
          <el-input-number v-model="currentEvalItem.defaultScore" :precision="1" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="赋分上限" prop="maxScore">
          <el-input-number v-model="currentEvalItem.maxScore" :precision="1" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="关联附件" prop="needAttach">
          <el-switch v-model="currentEvalItem.needAttach">
          </el-switch>
        </el-form-item>
        <el-form-item label="排序" prop="displayOrder">
          <el-input-number v-model="currentEvalItem.displayOrder" :precision="0" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentEvalItem.note" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.evalItemForm = false">取 消</el-button>
      <el-button type="primary" @click="saveEvalItem()">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="教师选择" :visible.sync="visible.selectStaff" v-loading="loading.selectStaff" width="40%" :close-on-click-modal="false">
      <el-card shadow="hover" style="margin: 10px;">
        <div>
          <el-form :inline="true" :model="staffCondition" class="demo-form-inline" size="mini">
            <el-form-item label="工号">
              <el-input v-model="staffCondition.seriaNo" placeholder="工号"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
              <el-input v-model="staffCondition.staffName" placeholder="姓名"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="findStaffByCondition">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="staffList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="工号" prop="seriaNo"></el-table-column>
          <el-table-column label="教师" prop="staffName"></el-table-column>
        </el-table>
      </el-card>
      <div style="clear: both;"></div>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.selectStaff = false" size="small">取 消</el-button>
      <el-button type="primary" @click="selectedStaff" size="small">选 中</el-button>
     </span>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name: 'EvalSetting',
  data() {
    return {
      title: '评选设定',
      // 遮罩
      loading: {index: false, edit: false, selectStaff: false},
      // 可见
      visible: {evalSubjectForm: false, evalItemForm: false, selectStaff: false},
      // Combo
      itemTypeCombo: [],

      // 当前评优
      currentEval: {},
      currentEvalSubject: {},
      currentEvalItem: {},
      evalSubjectList:[],
      evalItemList:[],
      evalItemOptionList:[],
      attachList: [],
      scopeList: [],
      fileList: [],
      // 校验规则
      serverRules: {
        itemName: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        standard: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        itemType: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        defaultScore: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        maxScore: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      },
      // 选择教职工
      staffList: [],
      staffSelection: [],
      staffCondition: {seriaNo: '', staffName: ''},
    }
  },

  /*
   * 初始化
   */
  mounted: function () {
    var vm = this,
        query = vm.$route.query;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight - vm.$baize.frameTitleHeight) + 'px';
    vm.findCombo();
    vm.findEval(query.id);
    vm.findEvalSubject(query.id);
    vm.findEvalAttach(query.id);
    vm.findEvalScope(query.id);
  },

  methods: {

    goBack: function () {
      var vm = this;
      // 作为正常页面打开
      vm.$router.push({path: '/Eval/manage'});
    },

    findCombo: function () {
      var vm = this;
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: {className:"com.megrezsoft.app.business.common.enumitem.EvalItemType", blank:false}}).then(response => {
        // 更新数据
        vm.itemTypeCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },

    findEval: function (evalId) {
      var vm = this;
      if (evalId) {
        vm.$http.get('rest/eval/findById', {params: {id: evalId}}).then(function (response) {
          // 刷新
          vm.currentEval = response.body;
          vm.title = vm.currentEval.title + ' | 评选设定';
          // 提示
          // vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    findEvalSubject: function (evalId) {
      var vm = this;
      vm.evalSubjectList = [];
      if (evalId) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.get('rest/eval/findEvalSubject', {params: {evalId: evalId}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.evalSubjectList = response.body.evalSubjectList;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    addEvalSubject: function (record) {
      var vm = this;
      vm.currentEvalSubject = {id:null, evalId: vm.currentEval.id, subjectName:null, note:null};
      vm.visible.evalSubjectForm = true;
    },

    showEvalSubject: function (record) {
      var vm = this;
      vm.currentEvalSubject = JSON.parse(JSON.stringify(record));
      vm.visible.evalSubjectForm = true;
    },

    deleteEvalSubject: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】记录[' + record.subjectName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.delete('rest/eval/deleteEvalSubject', {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          vm.findEvalSubject(vm.currentEval.id);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    saveEvalSubject: function () {
      var vm = this;
      // 校验
      vm.$refs['evalSubjectForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['evalSubjectForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.post('rest/eval/saveEvalSubject', vm.currentEvalSubject).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 关闭窗口
          vm.visible.evalSubjectForm = false;
          // 刷新
          vm.findEvalSubject(vm.currentEval.id);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      });
    },

    handleEvalSubjectChange: function (record) {
      var vm = this;
      vm.currentEvalSubject = record || {};
      vm.findEvalItem();
    },

    findEvalItem: function () {
      var vm = this;
      vm.evalItemList = [];
      if (vm.currentEvalSubject.id) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.get('rest/eval/findEvalItem', {params: {evalSubjectId: vm.currentEvalSubject.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.evalItemList = response.body.evalItemList;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    addEvalItem: function () {
      var vm = this;
      vm.currentEvalItem = {id:null, evalSubjectId: vm.currentEvalSubject.id, itemName:null, standard:null, itemType:null, defaultScore:0, maxScore:0, needAttach:false, displayOrder:0, note:null, options:[]};
      vm.visible.evalItemForm = true;
    },

    showEvalItem: function (record) {
      var vm = this;
      vm.currentEvalItem = JSON.parse(JSON.stringify(record));
      vm.visible.evalItemForm = true;
    },

    deleteEvalItem: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】记录[' + record.itemName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.delete('rest/eval/deleteEvalItem', {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          vm.findEvalItem();
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    saveEvalItem: function () {
      var vm = this;
      // 校验
      vm.$refs['evalItemForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['evalItemForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.post('rest/eval/saveEvalItem', vm.currentEvalItem).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 关闭窗口
          vm.visible.evalItemForm = false;
          // 刷新
          vm.findEvalItem();
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      });
    },

    uploadProgress: function (event, file, fileList) {
      var vm = this;
      // 开启遮罩
      vm.loading.index = true;
    },
    uploadError: function (err, file, fileList) {
      var vm = this;
      // 关闭遮罩
      vm.loading.index = false;
      // 弹出错误信息
      this.$alert(JSON.parse(err.message).message, '警告', {
        confirmButtonText: '确定',
        type: 'error'
      });
    },
    uploadSuccess: function (res,file) {
      var vm = this;
      // 关闭遮罩
      vm.loading.index = false;
      // 提示
      vm.$notify({position: 'bottom-right', type: res.status, message: res.msg});
      vm.findEvalAttach(vm.currentEval.id);
    },

    findEvalAttach: function (evalId) {
      var vm = this;
      vm.attachList = [];
      if (evalId) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.get('rest/eval/findEvalAttach', {params: {evalId: evalId}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.attachList = response.body.attachList;
          // 提示
          // vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    deleteEvalAttach: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】附件[' + record.fileName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.delete('rest/eval/deleteEvalAttach', {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          vm.findEvalAttach(vm.currentEval.id);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    findEvalScope: function (evalId) {
      var vm = this;
      vm.scopeList = [];
      if (evalId) {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.get('rest/eval/findEvalScope', {params: {evalId: evalId}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 刷新
          vm.scopeList = response.body.scopeList;
          // 提示
          // vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },

    deleteEvalScope: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】教职工[' + record.staffName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.index = true;
        // 请求后台
        vm.$http.delete('rest/eval/deleteEvalScope', {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          vm.findEvalScope(vm.currentEval.id);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.index = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },

    /**
     * 点击“选择教职工”
     */
    selectStaff : function () {
      var vm = this;
      vm.visible.selectStaff = true;
      vm.findStaffByCondition();
    },

    /**
     * 根据条件查询教职工
     */
    findStaffByCondition: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.selectStaff = true;
      // 请求后台
      vm.$http.get('rest/eval/findStaffByCondition', {params: {seriaNo:vm.staffCondition.seriaNo, staffName:vm.staffCondition.staffName}}).then(function (response) {
        // 关闭遮罩
        vm.loading.selectStaff = false;
        // 刷新
        vm.staffList = JSON.parse(response.bodyText) ;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.selectStaff = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    handleSelectionChange: function (val) {
      var vm = this;
      vm.staffSelection = val;
    },

    /**
     * 选中教职工
     */
    selectedStaff: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.selectStaff = true;
      // 请求后台
      vm.$http.post('rest/eval/selectedStaff?evalId='+vm.currentEval.id, vm.staffSelection).then(function (response) {
        // 关闭遮罩
        vm.loading.selectStaff = false;
        vm.visible.selectStaff = false;
        vm.findEvalScope(vm.currentEval.id);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.selectStaff = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },

    changeItemType: function (value) {
      var vm = this;
      if (value === '文本框') {
        vm.currentEvalItem.options = [];
      }
    },

    addOption: function () {
      var vm = this;
      vm.currentEvalItem.options.push({
        id: null,
        optionName: '',
        score: null
      });
    },

    removeOption(record) {
      var vm = this;
      var index = vm.currentEvalItem.options.indexOf(record);
      if (index !== -1) {
        vm.currentEvalItem.options.splice(index, 1);
      }
    },

  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/app/EvalSetting.vue